import { makeStyles, Paper, Theme } from "@material-ui/core";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    "& p": {
      textAlign: "justify",
      hyphens: "auto",
    },
  },
}));

export default function TermsOfUse()
{
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Paper className={classes.root} dangerouslySetInnerHTML={{ __html: t("partnerPortal.termsOfUse") }} />
  );
}
